import { ComponentProps } from 'react';
import Segmented from 'antd/es/segmented';
import clsx from 'clsx';

interface OpSegmentedProps extends ComponentProps<typeof Segmented> {
  testId?: string;
}

/**
 * OpSegmented is a wrapper around Ant Design's Segmented component.
 * It provides a segmented control for selecting a single option from a compact button group.
 * 
 * Use this component for filtering, view switching, or any scenario where users select between
 * a small number of mutually exclusive options with equal visual weight.
 * 
 * @example
 * <OpSegmented
 *   options={['Daily', 'Weekly', 'Monthly']}
 *   value={view}
 *   onChange={setView}
 * />
 * 
 */
export const OpSegmented = ({
  className,
  testId = 'op-segmented',
  ...segmentedProps
}: OpSegmentedProps) => {
  return (
    <Segmented
      className={clsx('op-segmented', className)}
      data-testid={testId}
      {...segmentedProps}
    />
  );
};
